import { useEffect } from "react";
import { useLocation, useNavigationType } from "react-router-dom";
import { trackPageView, trackViewContent } from "@/lib/analytics";
import { trackGaPageView } from "@/lib/googleAnalytics";

// Tool / solution landing pages → Meta ViewContent name. Every other route still
// gets a PageView; only the pages listed here additionally fire ViewContent.
const VIEW_CONTENT_BY_PATH: Record<string, string> = {
  // High-intent core pages (previously PageView-only).
  "/": "Home",
  "/pricing": "Pricing",
  "/contact": "Contact",
  "/about": "About",
  "/gallery": "Gallery",
  "/virtual-try-on": "Virtual Try-On",
  "/product-videos": "Product Videos",
  "/talking-avatars": "Talking Avatars",
  "/ugc-videos": "UGC Videos",
  "/upscale-video": "Upscale Video",
  "/caption-videos": "Caption Videos",
  "/fashion-reels": "Fashion Reels",
  "/cgi-videos": "CGI Videos",
  "/background-replacer": "Background Replacer",
  "/product-showcase": "Product Showcase",
  "/ghost-mannequin": "Ghost Mannequin",
  "/flat-lay": "Flat Lay",
  "/remove-background": "Remove Background",
  "/upscale": "Upscale",
  "/resize": "Resize",
  "/edit-with-ai": "Edit with AI",
  "/solutions/fashion": "Solution: Fashion",
  "/solutions/ecommerce": "Solution: Ecommerce",
  "/solutions/accessories": "Solution: Accessories",
  "/solutions/jewellery": "Solution: Jewellery",
  "/solutions/automobile": "Solution: Automobile",
};

function viewContentName(pathname: string): string | undefined {
  // Handles both /dukaan-ads and the localized /:lang/dukaan-ads route.
  if (pathname === "/dukaan-ads" || pathname.endsWith("/dukaan-ads")) {
    return "Dukaan Ads";
  }
  return VIEW_CONTENT_BY_PATH[pathname];
}

const ScrollToTop = () => {
  const { pathname } = useLocation();
  const navigationType = useNavigationType();

  // Fire analytics on every route change (independent of scroll restoration,
  // so back/forward navigation is tracked too).
  useEffect(() => {
    trackPageView();
    trackGaPageView();
    const name = viewContentName(pathname);
    if (name) trackViewContent(name);
  }, [pathname]);

  useEffect(() => {
    // Don't scroll to top on back/forward navigation — let the browser
    // restore the previous scroll position so users return to where they were.
    if (navigationType === "POP") return;
    window.scrollTo(0, 0);
  }, [pathname, navigationType]);

  return null;
};

export default ScrollToTop;
